var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4686 6.27104H11.203C11.1311 6.27104 11.0623 6.30229 11.0139 6.35698L7.59359 10.2992V1.50073C7.59359 1.43198 7.53734 1.37573 7.46859 1.37573H6.53109C6.46234 1.37573 6.40609 1.43198 6.40609 1.50073V10.2992L2.98577 6.35698C2.9389 6.30229 2.87015 6.27104 2.79671 6.27104H1.53109C1.42484 6.27104 1.36702 6.39761 1.43734 6.47729L6.62327 12.4539C6.67015 12.5079 6.72811 12.5513 6.79321 12.581C6.85831 12.6108 6.92905 12.6261 7.00062 12.6261C7.07219 12.6261 7.14292 12.6108 7.20802 12.581C7.27313 12.5513 7.33108 12.5079 7.37796 12.4539L12.5623 6.47729C12.6326 6.39604 12.5748 6.27104 12.4686 6.27104Z",
    fill: "url(#paint0_linear_4229_2217)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4229_2217",
    x1: 7.0304,
    y1: 12.6873,
    x2: 7.0304,
    y2: 1.37573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2054E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C62FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.d5407bad85718167c6404cf1d2ad6c24.svg";
export { ForwardRef as ReactComponent };